import { initialStateOrderDetail } from '../edit-florder-detail/florder-detail.model';
import { TemplateState } from './template.interface';

export const initialStateTemplate: TemplateState = {
  template: initialStateOrderDetail,
  templates: [],
  loading: false,
  loadSuccess: false,
  saving: false,
  saveSuccess: false,
  saved: false,
  deleting: false,
  deleted: false,
  type: 'ORDER',
  editing: null,
};
